
(function() {
    'use strict';

    var extDeps = ['ui.bootstrap'];
    var module = angular.module('app.common.widgets.modal', extDeps);


    /**
     * Manages the different types of user messages in the application
     */

    module.factory('modalService', modalService);
    modalService.$inject = ['$q', '$uibModal','$timeout'];
    function modalService($q, $uibModal,$timeout) {

        var _modalsMap = {};

        return {
            notifyMessage: notifyMessage
            , openCustom: openCustom
            , newCancelFormConfirmModalOptions: newCancelFormConfirmModalOptions
            , newSignoutConfirmModalOptions: newSignoutConfirmModalOptions
            , newFormValidationErrorModalOptions: newFormValidationErrorModalOptions
        };

        function newCancelFormConfirmModalOptions(){
            return {
                title:'Cancel confirmation'
                    , message: 'Are you sure you want to cancel the form?'
                , type: 'info'
                , allowCancel: true
                , actions: {
                    ok: {title:'Yes - Cancel'}
                , cancel:{title:'No - Go back'}
                }
            };
        }

        function newSignoutConfirmModalOptions(){
            return {
                title:'Logout confirmation'
                , message: 'Are you sure you want to logout from myConnect?'
                , type: 'info'
                , allowCancel: true
                , actions: {
                    ok: {title:'Yes - Logout'}
                    , cancel:{title:'No - Go back'}
                }
            };
        }

        function newFormValidationErrorModalOptions(){
            return {
                title:'Validation error'
                , message: 'Some fields require your attention'
                , type: 'alert'
                , allowCancel: false
            };
        }

        function notifyMessage(options) {

            options.actions = options.actions || {
                    ok: { title:'OK' }
                    , cancel:{ title:'Cancel' }
                };

            return openBootrapUiModal(
                '/UI/app/common.widgets/messageDialog.html'
                , ''
                , true
                , createModelResolverFromData(options)
            );
        }

        function openCustom(options){
            return openBootrapUiModal(
                options.templateUrl
                , ''
                , true
                , createModelResolverFromData(options.payload)
            );
        }

        function openBootrapUiModal(templateUrl, size, animate, modelResolver) {

            var matches = templateUrl.match(/\/(\w+)\.html/i);
            if (matches.length < 2)
                return;

            // Figure out the appropriate controller to pass on to the modal
            var viewName = matches[1];
            var controller = viewName[0].toUpperCase() + viewName.substr(1) + 'Controller';

            // prevent 2 modals with same data from opening
            var key = templateUrl + angular.toJson(modelResolver);
            if (_modalsMap[key])
                return $q.reject({});
            _modalsMap[key] = 1;

            // open new modal
            return $uibModal.open({
                    animation: animate,
                    templateUrl: templateUrl,
                    controller: controller,
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'notification-dialog-modal',
                    size: size,
                    resolve: modelResolver,
                })
                .result
                .finally(function () {
                    _modalsMap[key] = undefined;

                    // Fix for IE11 jumping divs when deleting leave
                    var el = angular.element('.app-wrapper').css('overflow','hidden');
                    $timeout(function(){ el.css('overflow',''); },1);
                });
        }

        function createModelResolverFromData(data) {
            return {
                modalPayload: function () {
                    return data;
                }
            };
        }

    }


    /**
     * Centers the dialog in the screen
     */
    module.directive('modalDialogView', modalDialogViewDirective);
    modalDialogViewDirective.$inject = ['$timeout'];
    function modalDialogViewDirective($timeout) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element) {

                //$('.modal-dialog').on('touchmove', function(e) { e.stopPropagation() })

                    // element
                    //     .closest('.modal-dialog')
                    //     .css({ 'top':100});
                // // NOTE: This creates issues on safari phones
                // $timeout(_execute, 10);
                // function _execute() {
                //     element
                //         .closest('.modal-dialog')
                //         .css({
                //             'margin-top': function () {
                //                 var rt = ($(window).height() - $(this).height()) / 2
                //                     - parseInt($(this).css('padding-top'))
                //                     - 50;
                //                 return rt < 0 ? 10 : rt;
                //             }
                //         });
                // }

            }
        };
    }


    /**
     * Dinamically assigned contoller
     * Controls the actions inside the Message Dialog
     */
    module.controller('MessageDialogController', MessageDialogController);
    MessageDialogController.$inject=['$uibModalInstance', 'modalPayload'];
    function MessageDialogController($uibModalInstance, modalPayload) {
        var vm = this;
        vm.isMatch = _isMatch;
        vm.allowCancel = modalPayload.allowCancel;

        vm.okButton = {
            title: modalPayload.actions.ok.title
            , click: function() { $uibModalInstance.close('Ok'); }
        };

        vm.cancelButton = {
            title: modalPayload.actions.cancel.title
            , click: function() {  $uibModalInstance.dismiss('Cancel'); }
        };

        init();


        function init() {
            for (var x in modalPayload)
                vm[x] = modalPayload[x];
        }


        function _isMatch(exp, value) {
            return new RegExp(exp, 'i').test(value);
        }


    }


})();